import React from "react";
import { useForm } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { Forms } from "@/types/form";
import { handleErrorToast } from "@/utils/helpers";
import { sdk } from "@/config/medusa";
import { toast } from "sonner";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import schemas from "@/utils/schemas";
import { zodResolver } from "@hookform/resolvers/zod";

const ForgotPassword: React.FC = () => {
  const form = useForm<Forms["ForgotPassword"]>({
    resolver: zodResolver(schemas.forgotPassword),
    defaultValues: {
      email: "",
    },
  });

  const { control, handleSubmit } = form;

  const onSubmit = async (data: Forms["ForgotPassword"]) => {
    const { email } = data;

    try {
      await sdk.client.fetch(`/auth/vendor-admin/emailpass/reset-password`, {
        method: "POST",
        headers: { accept: "text/plain" },
        body: {
          identifier: email,
          metadata: {
            callback_url: `${window.location.origin}/reset-password?type=vendor-admin`,
          },
        },
      });
      toast.success(
        "We've sent a password reset link if the email is associated with an account."
      );
    } catch (error) {
      handleErrorToast(error);
      console.error(error);
    }
  };

  return (
    <Form {...form}>
      <form id="forgot-password-form" onSubmit={handleSubmit(onSubmit)} className="mb-6">
        <FormField
          control={control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  id="email"
                  type="email"
                  placeholder="Email"
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
};

export default ForgotPassword;
